import type { Product } from "@/types/product";

const createVariants = (sizes: string[], color: "Noir" | "Bleu" | "Noir et Rouge") => {
  const colorMap = {
    "Noir": "#000000",
    "Bleu": "#0000FF",
    "Noir et Rouge": "#000000"
  };
  return sizes.map(size => ({
    size,
    colorName: color,
    colorHex: colorMap[color]
  }));
};

export const products: Product[] = [
  {
    id: "f1",
    name: "Blouson Polaire Journey Core",
    description: "Blouson polaire confortable et chaud pour femme",
    price: 60,
    images: ["https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=800"],
    categories: ["Femmes", "Vestes"],
    variants: createVariants(["XS", "S", "M", "L", "XL", "2XL", "3XL"], "Noir"),
    published: false,
    has_sizes: true,
    has_colors: true,
    has_size_guide: false,
    size_guide: null
  },
  {
    id: "f2",
    name: "Gilet Matelassé Pliable Core 365 CE702W Prevail",
    description: "Gilet matelassé élégant et pratique",
    price: 85,
    images: ["https://images.unsplash.com/photo-1525171254930-643fc658b64d?w=800"],
    categories: ["Femmes", "Vestes"],
    variants: createVariants(["XS", "S", "M", "L", "XL", "2XL", "3XL"], "Noir"),
    published: false,
    has_sizes: true,
    has_colors: true,
    has_size_guide: false,
    size_guide: null
  },
  {
    id: "f3",
    name: "Veste Légère Non Doublée Motivate™",
    description: "Veste légère et confortable pour femme",
    price: 60,
    images: ["https://images.unsplash.com/photo-1539533018447-63fcce2678e3?w=800"],
    categories: ["Femmes", "Vestes"],
    variants: createVariants(["XS", "S", "M", "L", "XL", "2XL", "3XL"], "Noir"),
    published: false,
    has_sizes: true,
    has_colors: true,
    has_size_guide: false,
    size_guide: null
  },
  {
    id: "h1",
    name: "Veste Polaire Journey Core 365™ avec Zip",
    description: "Veste polaire chaude et confortable pour homme",
    price: 60,
    images: ["https://images.unsplash.com/photo-1617127365659-c47fa864d8bc?w=800"],
    categories: ["Hommes", "Vestes"],
    variants: createVariants(["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"], "Noir"),
    published: false,
    has_sizes: true,
    has_colors: true,
    has_size_guide: false,
    size_guide: null
  },
  {
    id: "h2",
    name: "Veste Polaire Journey Demi-Zip",
    description: "Veste polaire élégante avec demi-zip",
    price: 70,
    images: ["https://images.unsplash.com/photo-1611312449408-fcece27cdbb7?w=800"],
    categories: ["Hommes", "Vestes"],
    variants: createVariants(["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"], "Noir"),
    published: false,
    has_sizes: true,
    has_colors: true,
    has_size_guide: false,
    size_guide: null
  },
  {
    id: "h3",
    name: "Veste Doudoune Pliable Prevail",
    description: "Doudoune légère et compressible",
    price: 85,
    images: ["https://images.unsplash.com/photo-1608063615781-e2ef8c73f99e?w=800"],
    categories: ["Hommes", "Vestes"],
    variants: createVariants(["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"], "Noir"),
    published: false,
    has_sizes: true,
    has_colors: true,
    has_size_guide: false,
    size_guide: null
  },
  {
    id: "h4",
    name: "Hoodie avec Zipper Unisexe",
    description: "Hoodie zippé confortable et pratique",
    price: 60,
    images: ["https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=800"],
    categories: ["Hommes", "Vestes"],
    variants: createVariants(["S", "M", "L", "XL", "2XL", "3XL"], "Noir"),
    published: false,
    has_sizes: true,
    has_colors: true,
    has_size_guide: false,
    size_guide: null
  },
  {
    id: "h5",
    name: "Hoodie Noir Unisexe",
    description: "Hoodie confortable et stylé",
    price: 60,
    images: ["https://images.unsplash.com/photo-1578768079052-aa76e52ff62e?w=800"],
    categories: ["Hommes", "Vestes"],
    variants: createVariants(["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"], "Noir"),
    published: false,
    has_sizes: true,
    has_colors: true,
    has_size_guide: false,
    size_guide: null
  },
  {
    id: "h6",
    name: "Crewneck Noir Unisexe",
    description: "Sweatshirt col rond classique",
    price: 60,
    images: ["https://images.unsplash.com/photo-1572495641004-28421ae29b95?w=800"],
    categories: ["Hommes", "Vestes"],
    variants: createVariants(["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"], "Noir"),
    published: false,
    has_sizes: true,
    has_colors: true,
    has_size_guide: false,
    size_guide: null
  },
  {
    id: "h7",
    name: "Tee-Shirt Agro",
    description: "T-shirt classique et confortable",
    price: 30,
    images: ["https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=800"],
    categories: ["Hommes", "Vestes"],
    variants: createVariants(["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"], "Noir"),
    published: false,
    has_sizes: true,
    has_colors: true,
    has_size_guide: false,
    size_guide: null
  },
  {
    id: "h8",
    name: "Polo Noir Homme Dry Fit",
    description: "Polo technique et respirant",
    price: 50,
    images: ["https://images.unsplash.com/photo-1598033129183-c4f50c736f10?w=800"],
    categories: ["Hommes", "Vestes"],
    variants: createVariants(["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"], "Noir"),
    published: false,
    has_sizes: true,
    has_colors: true,
    has_size_guide: false,
    size_guide: null
  },
  {
    id: "h9",
    name: "Chemise de Travail à Manches Longues",
    description: "Chemise de travail robuste et confortable",
    price: 75,
    images: ["https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?w=800"],
    categories: ["Hommes", "Vestes"],
    variants: [
      ...createVariants(["S", "M", "L", "XL", "2XL"], "Noir"),
      ...createVariants(["S", "M", "L", "XL", "2XL"], "Bleu")
    ],
    published: false,
    has_sizes: true,
    has_colors: true,
    has_size_guide: false,
    size_guide: null
  },
  {
    id: "h10",
    name: "Chemise de Travail à Manches Courtes 137",
    description: "Chemise de travail été",
    price: 75,
    images: ["https://images.unsplash.com/photo-1563630423918-b58f07336ac5?w=800"],
    categories: ["Hommes", "Vestes"],
    variants: [
      ...createVariants(["S", "M", "L", "XL", "2XL"], "Noir"),
      ...createVariants(["S", "M", "L", "XL", "2XL"], "Bleu")
    ],
    published: false,
    has_sizes: true,
    has_colors: true,
    has_size_guide: false,
    size_guide: null
  },
  {
    id: "h11",
    name: "Veste Duck sans Manches Doublée en Sherpa",
    description: "Veste sans manches chaude et résistante",
    price: 99,
    images: ["https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=800"],
    categories: ["Hommes", "Vestes"],
    variants: createVariants(["S", "M", "L", "XL", "2XL"], "Noir"),
    published: false,
    has_sizes: true,
    has_colors: true,
    has_size_guide: false,
    size_guide: null
  },
  {
    id: "p1",
    name: "Pantalon Big Bill",
    description: "Pantalon de travail résistant et confortable",
    price: 60,
    images: ["https://images.unsplash.com/photo-1542272604-787c3835535d?w=800"],
    categories: ["Pantalons", "Vestes"],
    variants: [
      ...createVariants(["M", "L", "XL"], "Noir"),
      ...createVariants(["M", "L", "XL"], "Bleu")
    ],
    published: false,
    has_sizes: true,
    has_colors: true,
    has_size_guide: false,
    size_guide: null
  },
  {
    id: "p2",
    name: "Pantalon de Travail Durable",
    description: "Ce pantalon de travail durable est fabriqué à 65 % en polyester recyclé et à 35 % en coton. La bande du short est dotée d'un élastique à l'arrière, pour un meilleur ajustement. Le short est doté de poches latérales, le poches arrière et d'une poche mètre. Au-dessus du genou, une pièce en tissu élastique a été ajoutée pour plus de confort et des espaces ont été pratiqués au niveau du genou, pour permettre l'application de protège-genoux. La poche arrière et la poche latérale présentent un logo Lely. Les éléments réfléchissants sur les poches latérales et dans le bas des jambes garantissent une bonne visibilité.\n\nFibres textiles utilisées : 65 % polyester recyclé / 35 % coton\nType de logo : badge brodé\nDessin : uni\nCoupe : coupe normale\nType de fermeture : fermeture éclair (braguette)\nHauteur de taille : normale\nCollection : vêtements de travail\nCouleur : noir et rouge",
    price: 89.99,
    images: ["https://images.unsplash.com/photo-1542272604-787c3835535d?w=800"],
    categories: ["Pantalons", "Vêtements de Travail"],
    variants: createVariants(["28", "30", "32", "34", "36", "38", "40", "42", "44"], "Noir et Rouge"),
    published: true,
    has_sizes: true,
    has_colors: true,
    has_size_guide: true,
    size_guide: {
      "28": { "Largeur": "36", "Longueur": "76" },
      "30": { "Largeur": "38", "Longueur": "76" },
      "32": { "Largeur": "40", "Longueur": "76" },
      "34": { "Largeur": "42", "Longueur": "76" },
      "36": { "Largeur": "44", "Longueur": "76" },
      "38": { "Largeur": "46", "Longueur": "76" },
      "40": { "Largeur": "48", "Longueur": "76" },
      "42": { "Largeur": "50", "Longueur": "76" },
      "44": { "Largeur": "52", "Longueur": "76" }
    }
  }
];
